import React from 'react'
import DeleteSweep from '@material-ui/icons/DeleteSweep'

export default function DeleteSweepIcon(props) {
    const { ...other } = props

    return (
        <DeleteSweep { ...other }  />
    )
}